<template>
  <div>
    <template v-if="d_selectedProject.id && d_searchProjectList.length && !d_showList">
      <b-row>
        <b-col sm="12" lg="9">
        </b-col>
        <b-col sm="12" lg="3">
          <b-button v-if="d_showList" @click="d_showList = !d_showList" variant="outline-primary" style="width: 100%; margin-top:10px;">
            <i class="fa fa-search"></i>
          </b-button>
          <b-button v-else @click="d_showList = !d_showList" variant="outline-primary" style="width: 100%; margin-top:10px;">
            <i class="fa fa-arrow-left"></i> {{ StoreLangTranslation.data['search_list'][StoreLang] }}
          </b-button>
        </b-col>
      </b-row>
    </template>
    <template v-if="d_showList">
      <b-row>
        <b-col sm="12" lg="10">
          <b-form-input v-model="d_searchText" :placeholder="StoreLangTranslation.data['search_algorithms'][StoreLang]" @keyup.enter="f_search()"></b-form-input>
        </b-col>
        <b-col sm="12" lg="2">
          <b-button v-if="!d_isSearching" @click="f_search()" variant="outline-primary" style="width: 100%;">
            <i class="fa fa-search"></i>
          </b-button>
          <b-button v-if="d_isSearching" style="width: 100%;" variant="outline-primary" disabled>
            <b-spinner variant="primary" style="width: 18px; height: 18px;" label="Searching"></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </template>
    <template v-if="d_isSearched && d_showList && d_searchProjectList.length">
      <b-row style="margin: 15px 0px;">
        <b-col sm="12" lg="12" style="padding: 0px;">
          {{ StoreLangTranslation.data['search_results'][StoreLang] }}
        </b-col>
      </b-row>
      <template v-for="(project, project_index) in d_searchProjectList">
        <b-row @click="f_selectProject(project)" style="cursor: pointer;" class="project-row">
          <b-col sm="12" lg="1">
            {{ project_index+1 }} )
          </b-col>
          <b-col sm="12" lg="11">
            <span> {{ project.name }} </span>
          </b-col>
        </b-row>
        <hr v-if="project_index !== d_searchProjectList.length - 1" style="margin:5px 0px" />
      </template>
    </template>
    <template v-else-if="d_isSearched && !d_searchProjectList.length">
      <b-row style="margin: 15px 0px;">
        <b-col sm="12" lg="12">
          {{ StoreLangTranslation.data['search_not_found'][StoreLang] }}
        </b-col>
      </b-row>
    </template>
    <template v-if="d_selectedProject.id && d_applicationFrontendUri && !d_showList">
      <wanalyzer-cell-calculate :p_projectId="d_selectedProject.id" :p_idType="d_idType" p_screenModeChange='no'></wanalyzer-cell-calculate>
    </template>
  </div>
</template>

<script>
import { ServiceFunctions } from '@/wam/modules/service';
import { mapGetters } from 'vuex';
import {
  default as WanalyzerCellCalculate
} from "@/components/widgets/WanalyzerCellCalculate";
export default {
  name: 'WaiProjectSearch',
  computed: mapGetters({
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreDevice: 'StoreDevice',
    StoreCurrencyType: 'StoreCurrencyType',
  }),
  props: {
    p_searchType: {
      type: String,
      required: false
    }
  },
  components: {
    WanalyzerCellCalculate
  },
  data () {
    return {
      d_searchText: '',
      d_searchProjectList: [],
      d_showList: true,
      d_selectedProject: {},
      d_isSearching: false,
      d_isSearched: false,
      d_frontendLoading: false,
      d_applicationFrontendUri: '',
      d_searchType: '0',
      d_iframeLink: '',
      d_idType: '',
      d_iframeMode: false
    }
  },
  created: function () {
    this.d_applicationFrontendUri = this.StoreFrontendSettings.data.application_frontend_uri;
    if (this.$route.meta.iframe_mode === 'yes') {
      this.d_iframeMode = true;
    }
    if (this.p_searchType) {
      this.d_searchType = this.p_searchType;
    } else if(!this.p_searchType) {
      if (this.$route.query.search_type !== undefined) {
        this.d_searchType = this.$route.query.search_type;
      }
    }
    if (this.d_searchType == '0') {
      // Şimdilik hepsi durumu client id based olarak eklendi. Daha sonra update edilebilir.
      this.d_idType = 'client_id_based';
    } else if (this.d_searchType == '1') {
      this.d_idType = 'client_id_based';
    } else if (this.d_searchType == '2') {
      this.d_idType = 'no';
    }
    if (this.d_iframeMode) {
      if (this.$route.query.search_text !== undefined) {
        this.d_searchText = this.$route.query.search_text;
        this.f_search();
      }
    }
  },
  mounted: function () {
    //
  },
  methods: {
    f_search: function () {
      if (this.d_isSearching) {
        alert(this.StoreLangTranslation.data['search_continues'][this.StoreLang]);
      } else {
        this.d_isSearching = true;
        let query = 'search_type=' + this.d_searchType; // 0: hepsi, 1: yalnızca client id bazlı, 2: yalnızca client id bazlı olmayanlar
        let data = {
          'search_text': this.d_searchText
        };
        ServiceFunctions.wai_search(query, data)
          .then(resp => {
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              // console.log(resp.data);
              this.d_searchProjectList = resp.data.list;
              this.d_selectedProject = {};
              this.d_showList = true;
              this.d_isSearched = true;
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
            this.d_isSearching = false;
          });
      }
    },
    f_selectProject: function (project) {
      this.d_selectedProject = project;
      this.d_showList = false;
      this.d_iframeLink = this.d_applicationFrontendUri + '/wanalyzer-cell-calculate-iframe?project_id=' + this.d_selectedProject.id + '&screen_mode=1';
    }
  },
  watch: {
  }
}
</script>

<style>
.project-row {
  padding: 10px 0px;
  transition: background-color 0.2s ease;
  border-radius: 5px;
}

.project-row:hover {
  background-color: #e6f2ff;
}
</style>
